export default __webpack_public_path__ + "static/media/spaced-logo-white.bfaebb25.svg";